import { ActualsDefinitionViewModel } from '@/models/api';

export function ConvertProductionRateTypeToComparisonString(productionRateType?: string) {
    switch (productionRateType) {
        case 'Conventional Bogging':
        case 'ConventionalBogging':
            return 'Bogging';
        case 'Remote Bogging':
        case 'RemoteBogging':
            return 'Bogging';
        default:
            return productionRateType;
    }
}


export function ConvertTaskClassToString(taskClass?: number) {
    switch (taskClass) {
        case 0:
            return 'User Defined';
        case 2:
            return 'Conventional Bogging';
        case 3:
            return 'Remote Bogging';
        case 4:
            return 'Drilling';
        case 5:
            return 'Misfire';
        case 6:
            return 'Strip';
        case 7:
            return 'Did Not Fire';
        case 8:
            return 'Fire';
        case 9:
            return 'Wait';
        case 10:
            return 'Charge';
        default:
            return 'Unknown';
    }
}

export function ConvertTaskClassToTypesComparisonString(taskClass?: number) {
    switch (taskClass) {
        case 0:
            return 'User Defined';
        case 2:
            return 'Bogging';
        case 3:
            return 'Bogging';
        case 4:
            return 'Drilling';
        case 5:
            return 'Misfire';
        case 6:
            return 'Strip';
        case 7:
            return 'Did Not Fire';
        case 8:
            return 'Fire';
        case 9:
            return 'Wait';
        case 10:
            return 'Charge';
        default:
            return 'Unknown';
    }
}

export function IsNumericActualsDefinition(definitionType?: string | null): boolean {
    return definitionType === 'Integer' || definitionType === 'Decimal' || definitionType === 'Formula';
}
